import { CREATE_CLIENT } from "../actions/types"

export default function _(state = null, action) {
    switch(action.type) {
        case CREATE_CLIENT:
            return action.payload
        default:
            return state
    }
}